import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=4b70555a&"
import script from "./CategoryItems.vue?vue&type=script&lang=js&"
export * from "./CategoryItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports